// eslint-disable-next-line max-len
import { type EventApplicationEntrypointContextDataFragment } from '../../../api/fragments/EventApplicationEntrypointContextData';
import { useSingleDealerId } from '../../../components/contexts/DealerContextManager';
import withPrivateAccess from '../../../utilities/withPrivateAccess';
import EventList from '../../shared/EventList';

type EventListProps = {
    endpoint: EventApplicationEntrypointContextDataFragment;
};
const EventListPage = ({ endpoint }: EventListProps) => {
    const { eventApplicationModule } = endpoint;
    const { id } = eventApplicationModule;
    const { dealerId } = useSingleDealerId();

    return <EventList dealerIds={[dealerId]} moduleId={id} pageType="Portal" />;
};

export default withPrivateAccess(EventListPage);
